var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVyzerLogoWithGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 170,
    viewBox: "0 0 180 170",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_11793_269706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4585 50.0898L97.4396 106.758L89.9879 119.961L50.5552 50.0898H65.4585ZM80.3619 50.0898L87.7401 63.1643H107.138L97.4396 80.3498L104.891 93.5529V93.5553L129.422 50.0898H80.3619Z",
    fill: "#FFBBBB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4585 50.0898L97.4396 106.758L89.9879 119.961L50.5552 50.0898H65.4585ZM80.3619 50.0898L87.7401 63.1643H107.138L97.4396 80.3498L104.891 93.5529V93.5553L129.422 50.0898H80.3619Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11793_269706",
    x: -9,
    y: -20,
    width: 198,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_11793_269706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyzerLogoWithGlow);
export default __webpack_public_path__ + "static/media/vyzer-logo-with-glow.621fb0e2ca49ee0ce506b9e02f7aa455.svg";
export { ForwardRef as ReactComponent };